import React from "react";
import { Legacy_CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import { Props_SnippetImageAndTextHeadline } from "./ImageAndTextHeadline.props";

export const SnippetImageAndTextHeadline = (
  props: Props_SnippetImageAndTextHeadline
) => {

  const titleClass = props.heading.visibility.value === "visible" ? "snippet-image-and-text-headline__title" : "snippet-image-and-text-headline__title accessible-heading";

  return (
    <section className="snippet-image-and-text-headline">
      <div className="snippet-image-and-text-headline__container">
        <h2 className={titleClass}> {props.heading?.heading?.value} <span className="snippet-image-and-text-headline__title--highlight">{props.heading?.headinghighlight?.value} </span> </h2>

        {props.image && (
          <div className="snippet-image-and-text-headline__image-section">
            <figure className="snippet-image-and-text-headline__image-container">
              <img
                className="snippet-image-and-text-headline__image"
                src={props.image.src?.value}
                alt={props.image.alt?.value}
                height="735"
                width="560"
                loading="lazy"
              />
            </figure>
          </div>
        )} 
         <div className="snippet-image-and-text-headline__content-section">    
            <div className="snippet-image-and-text-headline__text"> {Legacy_CompileMarkdown(props.markdown?.markdown?.value || "")} </div>
        </div>
      </div>
    </section>
  );
};
